/*
 * Module for listing the standard responses
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "modules/topicsSplit/topics/standardResponsesList/standardResponsesListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/topicsSplit/topics/standardResponsesList/standardResponsesListModel",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  Backbone,
  $,
  _,
  Messenger,
  StandardResponsesListView,
  SortableListModule,
  // eslint-disable-next-line no-unused-vars
  StandardResponsesListModel,
  KbMenuModel,
) {
  var StandardResponsesListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "standardResponsesList";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (standardResponses) {
      var headers = Messenger.reqres.request("standard:responses:headers");
      var responseVersioning = Messenger.reqres
        .request("active:kb:model")
        .get("responseVersioning");
      var model = new Backbone.Model({
        responseVersioning: responseVersioning,
      });
      this.layout = new StandardResponsesListView.standardResponsesListLayout({ model: model });
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
        }),
      );
      //publish standard responses with pending responses
      this.layout.on(
        "publish",
        function () {
          //get the checked models from the sortable list (with namespace)
          var pendingStandardResponses = Messenger.reqres.request(
            "standardResponsesList:checked:models",
          );
          _.each(
            pendingStandardResponses,
            function (standardResponse) {
              //for each checked standard response, check to see if it has a pending response status
              if (
                standardResponse.get("statusId") === KbMenuModel.statuses.VERSIONED_PENDING_RESPONSE
              ) {
                standardResponse.set("statusId", KbMenuModel.statuses.VERSIONED_PUBLISHED);
                standardResponse.liveResponse.needToPublish = true; //mark as needing to be published
                standardResponse.liveResponse.publishAll = true;
              }
            },
            this,
          );
          //save, causing any publishes to be requested
          Messenger.save(function (success) {
            if (success) {
              //close menu
              this.layout.closeStatusMenu();
              //uncheck all of the checkboxes
              Messenger.vent.trigger("standardResponsesList:toggle:all:checkboxes", false);
            }
          }, this);
        },
        this,
      );
      this.layout.on(
        "open:topic:status:menu",
        function () {
          //clear any old errors
          this.clearError();
          var selectedStandardResponses = Messenger.reqres.request(
            "standardResponsesList:checked:models",
          );
          //check if there are any selected models
          if (selectedStandardResponses.length > 0) {
            this.layout.showStatusMenu();
          } else {
            this.standardResponsesError($.t("topics.controls.emptyChangeStatus"));
            //close the menu (even though it's invisible, the button appears different)
            this.layout.closeStatusMenu();
          }
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(standardResponses);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    clearError: function () {
      this.layout.clearError();
    },
    standardResponsesError: function (errorMessage) {
      this.layout.standardResponsesError(errorMessage);
    },
    _showSubViews: function (standardResponse) {
      this.list.show(standardResponse);
    },
    _setUpVents: function () {
      //selected a standard response from the sortable list
      Messenger.vent.on(
        "standardResponsesList:selected:row",
        function (model) {
          //trigger event to show the standard response
          Messenger.vent.trigger("show:standard:response", model);
        },
        this,
      );
    },
  });

  return StandardResponsesListController;
});
